import { render, staticRenderFns } from "./SonEntityPerformanceChart.vue?vue&type=template&id=8084fe56&"
import script from "./SonEntityPerformanceChart.vue?vue&type=script&lang=js&"
export * from "./SonEntityPerformanceChart.vue?vue&type=script&lang=js&"
import style0 from "./SonEntityPerformanceChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports